// extracted by mini-css-extract-plugin
module.exports = {"wordNumSection":"EditUserDescriptionForm_wordNumSection__3tlik","collectInfoDescription":"EditUserDescriptionForm_collectInfoDescription__2JqHN"};